import gql from 'graphql-tag'

export const usuarioFragment = gql`
  fragment UsuarioFragment on Usuario {
    id
    nome
    email
    keycloakId
    active
    ativacaoEspecial
    ausenteTemporariamente
    tipo {
      id
      description
    }
    marcas {
      id
      description
    }
    funcionalidades {
      id
      nome
      produto {
        id
        nome
      }
    }
    dealers {
      id
      nome
      nomeExibicao
      codigoPrincipal
    }
    dadosComplementares {
      id
      tipo
    }
  }
`

export const USUARIOS_PAGED_QUERY = gql`
  query UsuarioPaged($filterInput: UsuarioFilterInput!) {
    usuariosPaged(filterInput: $filterInput) {
      content {
        ...UsuarioFragment
      }
      totalElements
    }
  }
  ${usuarioFragment}
`
